<template lang="pug">
  .gvl-print-data.white
    #print-content.pa-8
      p.mt-3.mb-4 Angaben zur Antragstellerin bzw. dem Antragsteller
      applicant-information(ref="applicant-info" readonly)

      p.mt-6.mb-4 Bankverbindung
      bank-details(ref="bank-details" readonly)

      p.mt-6.mb-0.mbb-4 Angaben zur Förderberechtigung
      funding-information(ref="funding-info" readonly)

      p.mt-6.mb-4 Künstlerisches Konzept
      artistic-concept(ref="artistic-concept" readonly)

    v-layout.row.btn-row.px-8.py-4
      v-flex.xs6: v-btn.mr-2(color="primary" @click="onPrint") Drucken
      v-flex.xs6.text-right: v-btn.ml-2(color="primary"  outlined @click="$emit('close')") Schließen

</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { Printd } from 'printd'

import FormMixin from '@/mixins/form'

@Component({
  mixins: [
    FormMixin
  ],

  components: {
    ApplicantInformation: () => import('@/components/applicant-information'),
    BankDetails: () => import('@/components/bank-details'),
    FundingInformation: () => import('@/components/funding-information'),
    ArtisticConcept: () => import('@/components/artistic-concept'),
  }
})
export default class PrintData extends Vue {
  onPrint () {
    const d = new Printd({
      parent: document.body
    })

    let cssText = `
      * {
        font-family: "Roboto", sans-serif;
      }

      .row {
        display: block;
        width: 100%;
      }

      .col {
        display: block;
        width: 100%;
        padding: 12px 0;
      }

      .col, .col-12 {
        color: rgba(0, 0, 0, 0.87);
        line-height: 1.5;
        page-break-inside: avoid;
      }

      .col-6 {
        display: inline-block;
        width: 50%;
      }

      @page {
        margin-top: 30px;
        margin-bottom: 30px;
      }

      table {
        -webkit-print-color-adjust: exact;
      }

      label.primary--text {
        color: #024589;
        font-size: 14px;
        display: table;
        page-break-inside: avoid;
      }

      a {
        color: #024589;
      }

      .hint-label {
        display: table;
        page-break-inside: avoid;
        font-size: 0.875em;
        color: #666;
      }

      .text-preview {
        display: table;
        page-break-inside: avoid;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.87);
        margin-bottom: 0;
        padding-left: 12px;
        white-space: pre;
      }

      .text-default {
        font-size: 16px;
        color: #6E6E6E;
      }

      .file-label {
        display: table;
        page-break-inside: avoid;
        color: #024589;
        font-size: 14px;
        line-height: 1.25;
      }

      .ml-1 {
        margin-left: 4px;
      }

      .ml-8 {
        margin-left: 32px;
      }

      .mt-3 {
        margin-top: 12px;
      }

      .mt-6, .mtt-6 {
        margin-top: 24px;
      }

      .mt-8 {
        margin-top: 32px;
      }

      .mb-0 {
        margin-bottom: 0px;
      }

      .mb-1 {
        margin-bottom: 4px;
      }

      .mb-3 {
        margin-bottom: 12px;
      }

      .mb-4, .mbb-4 {
        margin-bottom: 16px;
      }

      .my-3 {
        margin-top: 12px;
        margin-bottom: 12px;
      }
    `

    // for (const node of [...document.querySelectorAll('style')]) {
    //   cssText += node.innerHTML
    // }

    d.print(document.getElementById('print-content'), [
      cssText,
      'https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900',
      'https://fonts.googleapis.com/css?family=Material+Icons'
    ])
  }
}
</script>

<style lang="sass">
.gvl-print-data
  position: relative
  padding-bottom: 60px

  #print-content
    max-height: calc(100vh - 200px)
    overflow: auto
    color: rgba(0, 0, 0, 0.87)

  .btn-row
    position: absolute
    bottom: 0
    left: 0
    right: 0
    margin: 0
</style>
